export default __webpack_public_path__ + "static/media/warning-open.43a072c9.svg";